import { render, staticRenderFns } from "./quickshopping.vue?vue&type=template&id=5db8469e&scoped=true&"
import script from "./quickshopping.vue?vue&type=script&lang=js&"
export * from "./quickshopping.vue?vue&type=script&lang=js&"
import style0 from "./quickshopping.vue?vue&type=style&index=0&id=5db8469e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db8469e",
  null
  
)

export default component.exports